module.exports = __webpack_public_path__ + "img/Bitdepth.dc8ff190.gif";